import { ErrorHandler, NgModule } from '@angular/core';
import { ApplicationinsightsAngularpluginErrorService } from '@microsoft/applicationinsights-angularplugin-js';
import { ApplicationInsightsService } from '../app/shared/services/insights.service';

@NgModule({
    providers: [
    ApplicationInsightsService,
    {
        provide: ErrorHandler,
        useClass: ApplicationinsightsAngularpluginErrorService,
    },
    ],
})
export class InsightsModule {
    constructor(private insightsService: ApplicationInsightsService) {}
}
